import { render, staticRenderFns } from "./OAList.vue?vue&type=template&id=e1fafa0a&scoped=true&"
import script from "./OAList.vue?vue&type=script&lang=js&"
export * from "./OAList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1fafa0a",
  null
  
)

export default component.exports